export enum ImageTypeEnum {
  LargeHeaderNat = 'LargeHeaderNat',
}

export const NOT_IMAGE_PROPERTY = 'not_image_property';
